<template>
  <div class="page-container">
    <span class="go-back-btn" @click="goBack" v-if="showBackBtn">首页</span>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    <footer class="fixed flex" v-if="$route.meta.showTab">
      <router-link to="index"><span class="icon icon-home">首页</span></router-link>
      <router-link to="orderlist"><span class="icon icon-order">订单</span></router-link>
      <router-link to="usercenter"><span class="icon icon-user">我的</span></router-link>
    </footer>
  </div>
</template>

<script>
import {actions} from "./store/actions";

export default {
  name: 'app',
  data (){
    return {
      clientHeight: 0,
      showBackBtn: false,
      // transitionName: 'slide-left'
    }
  },
  created() {
    window.appScroll = 0;
    localStorage.setItem('lastLogTime', new Date().getTime());
    localStorage.setItem('exposureLog', JSON.stringify([]));
  },
  mounted() {
    this.clientHeight = document.documentElement.clientHeight;
    if (document.domain.indexOf('xiyoushi.com') >= 0) {
      this.showBackBtn = true
    }
    // 创建cnzz统计js
    const script = document.createElement('script');
    script.src = "https://s96.cnzz.com/z_stat.php?id=1277660396&web_id=1277660396";
    script.language = 'JavaScript';
    document.body.appendChild(script);

    window.addEventListener('scroll', this.recordLog)
  },
  // beforeDestroy () {
  //   window.removeEventListener("scroll", this.recordLog)
  // },
  watch: {
    '$route': {
      handler(to, from) {
        setTimeout(() => { //避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location;
            let contentUrl = location.pathname + location.hash;
            let refererUrl = '/';
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_setAutoPageview', false]);
            window._czc.push(['_trackPageview', contentUrl, refererUrl]);
          }
        }, 300)
      },
      immediate: true  // 首次进入页面即执行
    }
  },
  methods: {
    recordLog () {
      window.appScroll = document.documentElement.scrollTop || document.body.scrollTop;
      let uid = localStorage.getItem('wxUid');
      if (this.$store.state.needRecord && (uid && uid != 'null')) {
        if (this.$store.state.recordPage === 'TagPage') {
          this.record1('asa_index_shop', 'id')
        } else if (this.$store.state.recordPage === 'TagPage2') {
          this.record('asa_merc_home_index_list', 'jump_target')
        } else if (this.$store.state.recordPage === 'ShopList') {
          this.record('asa_merc_shop_specialList', 'id')
        } else if (this.$store.state.recordPage === 'ShopList2') {
          this.record('asa_merc_shop_listForGoods_category', 'id')
        } else if (this.$store.state.recordPage === 'Search') {
          this.record('asa_merc_shop_search', 'id')
        } else if (this.$store.state.recordPage === 'OrderList') {
          this.record('asa_oc_order_list', 'supplierId')
        }
      }
    },
    record1 (code, key) {
      let uid = localStorage.getItem('wxUid') || 0;
      let exposureLog = localStorage.getItem('exposureLog');
      exposureLog = exposureLog ? JSON.parse(exposureLog) : [];
      let lastLogTime = localStorage.getItem('lastLogTime');
      let scrollTop = this.$store.state.recordOtherHeight;
      let itemHeight = this.$store.state.recordItemHeight;
      let idx = Math.round((this.clientHeight - scrollTop + window.appScroll) / itemHeight);
      let list = this.$store.state.recordList;
      // console.log('recode')
      // console.log(list)
      // console.log(code)
      // console.log('recode')
      let maxSize = Math.round(this.clientHeight/itemHeight);
      let current = localStorage.getItem('recordLogIdx') ? +localStorage.getItem('recordLogIdx') : 0;
      let indexId = localStorage.getItem('indexId') ? localStorage.getItem('indexId') : 200
      // console.log(list)
      if (current != idx) {
        if (idx > current) {
          let len = idx - current;
          for(let i=0;i < len; i++) {
            let addIdx = current + i;
            if (list[addIdx]) {
              exposureLog.push({
                uid: uid,
                firstValue:  this.$store.state.schoolInfo.schoolId,
                secondValue: indexId,
                refId: +list[addIdx][key],
                createTime: new Date().getTime(),
                code: code,
              })
            }
          }
          // console.log(exposureLog)
          localStorage.setItem('recordLogIdx', idx);
        } else if (idx < current && idx >= maxSize) {
          let max = current - idx, size = current - maxSize - 1;
          for(let i=0;i<max;i++) {
            if (size >= 0 && list[size]) {
              exposureLog.push({
                uid: uid,
                firstValue: this.$store.state.schoolInfo.schoolId,
                secondValue: indexId,
                refId: +list[size][key],
                createTime: new Date().getTime(),
                code: code,
              })
              size = size - 1;
            }
          }
          localStorage.setItem('recordLogIdx', idx);
        }
        if ((new Date().getTime - lastLogTime) >= (1000*60*5)) {
          this.pushLog(exposureLog);
        } else {
          // console.log(exposureLog)
          localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        }
      }
    },
    record (code, key) {
      let uid = localStorage.getItem('wxUid') || 0;
      let exposureLog = localStorage.getItem('exposureLog');
      exposureLog = exposureLog ? JSON.parse(exposureLog) : [];
      let lastLogTime = localStorage.getItem('lastLogTime');
      let scrollTop = this.$store.state.recordOtherHeight;
      let itemHeight = this.$store.state.recordItemHeight;
      let idx = Math.round((this.clientHeight - scrollTop + window.appScroll) / itemHeight);
      let list = this.$store.state.recordList;
      // console.log('recode')
      // console.log(list)
      // console.log(code)
      // console.log('recode')
      let maxSize = Math.round(this.clientHeight/itemHeight);
      let current = localStorage.getItem('recordLogIdx') ? +localStorage.getItem('recordLogIdx') : 0;

      // console.log(list)
      if (current != idx) {
        if (idx > current) {
          let len = idx - current;
          for(let i=0;i < len; i++) {
            let addIdx = current + i;
            if (list[addIdx]) {
              exposureLog.push({
                uid: uid,
                firstValue: addIdx,
                // shopid: list[addIdx][key],
                refId: +list[addIdx][key],
                createTime: new Date().getTime(),
                code: code,
              })
            }
          }
          // console.log(exposureLog)
          localStorage.setItem('recordLogIdx', idx);
        } else if (idx < current && idx >= maxSize) {
          let max = current - idx, size = current - maxSize - 1;
          for(let i=0;i<max;i++) {
            if (size >= 0) {
              exposureLog.push({
                uid: uid,
                firstValue: size,
                // shopid: list[size][key],
                refId: +list[size][key],
                createTime: new Date().getTime(),
                code: code,
              })
              size = size - 1;
            }
          }
          localStorage.setItem('recordLogIdx', idx);
        }
        if ((new Date().getTime - lastLogTime) >= (1000*60*5)) {
          this.pushLog(exposureLog);
        } else {
          // console.log(exposureLog)
          localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        }
      }
    },
    pushLog(list) {
      let _this = this;
      let params = {
        logDetails: list,
        source: 3,
      };
      actions.postLogAdd(_this, params,(res) => {
        if (res.body.message === "Success" && res.body.result) {
          localStorage.setItem('lastLogTime', new Date().getTime());
          localStorage.setItem('exposureLog', JSON.stringify([]));
        }
      },function () {

      })
    },
    goBack() {
      this.$router.push({path:'/index'})
      //验证是否存在记录
      // if ((navigator.userAgent.indexOf('MSIE') >= 0) && (navigator.userAgent.indexOf('Opera') < 0)){ // IE
      //   if(history.length > 0){
      //     window.history.go( -1 );
      //   }else{
      //     // window.location.href = "/index";
      //     this.$router.push({path:'/index'})
      //   }
      // }else{ //非IE浏览器
      //   if (navigator.userAgent.indexOf('Firefox') >= 0 ||
      //     navigator.userAgent.indexOf('Opera') >= 0 ||
      //     navigator.userAgent.indexOf('Safari') >= 0 ||
      //     navigator.userAgent.indexOf('Chrome') >= 0 ||
      //     navigator.userAgent.indexOf('WebKit') >= 0){
      //     console.log(window.history,'9999')
      //     if(window.history.length > 1){
      //       window.history.go( -1 );
      //     }else{
      //       // window.location.href = "/index";
      //       this.$router.push({path:'/index'})
      //     }
      //   }else{ //未知的浏览器
      //     window.history.go( -1 );
      //   }
      // }
    }
  }
}
</script>




// WEBPACK FOOTER //
// App.vue?6c3270be